import React from "react";
import { Dots } from "react-dot-patterns";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import AutoTyping, { BlinkCursor } from "react-auto-typing";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const IndustriesWeServe = () => {
  return (
    <>
      <div className="csd-industry-service-wrapper">
        <div className="dots1">
          <Dots
            col={5}
            row={4}
            size={5}
            rotate={90}
            margin={8}
            color={"#f3792c"}
            item={null}
            style={{}}
            evenRowShift={15}
            // evenColoumnShift={20}
          />
        </div>
        <div className="dots2">
          <Dots
            col={5}
            row={3}
            size={5}
            rotate={90}
            margin={5}
            color={"#f3792c"}
            item={null}
            style={{}}
            evenRowShift={-20}
            // evenColoumnShift={20}
          />
        </div>
        <div className="section-title">
          <h1 className="title">Industries We Serve</h1>
          <span className="subtitle" aria-hidden="true">
            <AutoTyping
              active // <boolean>
              textRef={"Industries"}
              writeSpeed={150}
              deleteSpeed={150}
              delayToWrite={1000}
              delayToDelete={1000}
            />
          </span>
        </div>

        <div className="csd-industry-service-details-container mb-5">
          <div className="csd-industry-service-details">
            <Swiper
              slidesPerView="auto"
              grabCursor={true}
              spaceBetween={25}
              navigation={true}
              loop={true}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              speed={500}
              modules={[Navigation, Pagination, Autoplay]}
              className="mySwiper"
              breakpoints={{
                768: {
                  slidesPerView: 3,
                },
              }}
            >
              <SwiperSlide>
                <div className="industires-card-wrapper">
                  <div className="card">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#f3792c"
                        d="M11 7.83A3 3 0 0 1 9 5a3 3 0 0 1 3-3a3 3 0 0 1 3 3c0 1.31-.84 2.42-2 2.83v2.81a3.66 3.66 0 0 0-2 0zm7.3 13.27a2.99 2.99 0 0 1-1.46-3.14l-2.44-1.41c.48-.46.84-1.05 1-1.73l2.44 1.41c.94-.81 2.32-.97 3.45-.32c1.44.83 1.93 2.66 1.1 4.09a2.987 2.987 0 0 1-4.09 1.1M2.7 15.9c1.13-.65 2.51-.48 3.45.32l2.45-1.41c.16.69.51 1.27 1 1.73l-2.45 1.41c.23 1.22-.32 2.5-1.45 3.15c-1.44.83-3.27.34-4.1-1.1a3 3 0 0 1 1.1-4.1M14 14a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2m3 0l-.03.57l-1.47-.86c-.1-1.07-.67-2-1.5-2.59V9.41c1.77.78 3 2.54 3 4.59m-2.03 4.03c-.83.61-1.86.97-2.97.97s-2.14-.36-2.97-1l1.47-.83c.46.21.97.33 1.5.33s1.03-.12 1.5-.33zm-7.94-3.47L7 14c0-2.05 1.23-3.81 3-4.58v1.71c-.83.58-1.4 1.51-1.5 2.57z"
                      />
                    </svg>
                    <h4 className="card-title">Healthcare</h4>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="industires-card-wrapper">
                  <div className="card">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="none"
                        stroke="#f3792c"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="32"
                        d="M322 416c0 35.35-20.65 64-56 64H134c-35.35 0-56-28.65-56-64m258-80c17.67 0 32 17.91 32 40h0c0 22.09-14.33 40-32 40H64c-17.67 0-32-17.91-32-40h0c0-22.09 14.33-40 32-40"
                      />
                      <path
                        fill="none"
                        stroke="#f3792c"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="32"
                        d="M344 336H179.31a8 8 0 0 0-5.65 2.34l-26.83 26.83a4 4 0 0 1-5.66 0l-26.83-26.83a8 8 0 0 0-5.65-2.34H56a24 24 0 0 1-24-24h0a24 24 0 0 1 24-24h288a24 24 0 0 1 24 24h0a24 24 0 0 1-24 24ZM64 276v-.22c0-55 45-83.78 100-83.78h72c55 0 100 29 100 84v-.22M241 112l7.44 63.97"
                      />
                      <path
                        fill="none"
                        stroke="#f3792c"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="32"
                        d="M256 480h139.31a32 32 0 0 0 31.91-29.61L463 112"
                      />
                      <path
                        fill="none"
                        stroke="#f3792c"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="32"
                        d="m368 112l16-64l47-16"
                      />
                      <path
                        fill="none"
                        stroke="#f3792c"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="32"
                        d="M224 112h256"
                      />
                    </svg>
                    <h4 className="card-title">Finance & FinTech</h4>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="industires-card-wrapper">
                  <div className="card">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 256 256"
                    >
                      <path
                        fill="#f3792c"
                        d="M230.17 13.71a12 12 0 0 0-11.82-.3L101 76H32a20 20 0 0 0-20 20v104a20 20 0 0 0 20 20h88a20 20 0 0 0 20-20v-32a11.9 11.9 0 0 0-.51-3.45L118.32 94L212 44v112h-12v-4a12 12 0 0 0-24 0v8a20 20 0 0 0 20 20h20a20 20 0 0 0 20-20V24a12 12 0 0 0-5.83-10.29M95.07 100l16.8 56H76v-56ZM52 100v56H36v-56Zm-16 96v-16h80v16Z"
                      />
                    </svg>
                    <h4 className="card-title">Manufacturing</h4>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="industires-card-wrapper">
                  <div className="card">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 24 24"
                    >
                      <g fill="none">
                        <path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                        <path
                          fill="#f3792c"
                          d="M15.764 4a3 3 0 0 1 2.683 1.658l1.383 2.765c.244-.1.487-.201.723-.318a1 1 0 0 1 .894 1.79c-.494.246-.72.322-.72.322l.956 1.913c.209.417.317.876.317 1.342V16a3 3 0 0 1-1 2.236V19.5a1.5 1.5 0 0 1-3 0V19H6v.5a1.5 1.5 0 0 1-3 0v-1.264c-.614-.55-1-1.348-1-2.236v-2.528a3 3 0 0 1 .317-1.341l.956-1.914a14 14 0 0 1-.718-.321a1 1 0 0 1-.45-1.343a1.01 1.01 0 0 1 1.347-.445q.354.17.718.315l1.383-2.765A3 3 0 0 1 8.236 4Zm3.07 6.904C17.134 11.441 14.715 12 12 12s-5.134-.56-6.834-1.096l-1.06 2.12a1 1 0 0 0-.106.448V16a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2.528a1 1 0 0 0-.106-.447l-1.06-2.12ZM7.5 13a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m9 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m-.736-7H8.236a1 1 0 0 0-.894.553L6.072 9.09C7.62 9.555 9.706 10 12 10s4.38-.445 5.927-.91l-1.269-2.537A1 1 0 0 0 15.764 6"
                        />
                      </g>
                    </svg>
                    <h4 className="card-title">Logistics & Supply Chain</h4>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="industires-card-wrapper">
                  <div className="card">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill="#f3792c"
                        d="M7.5 1a.5.5 0 0 0-.5.5V4q0 .063.015.122A4 4 0 0 0 4 8v1H2.5A1.5 1.5 0 0 0 1 10.5v4a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-4A1.5 1.5 0 0 0 13.5 9H12V8a4 4 0 0 0-4-4V3h1.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2 13v-2.25a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75V14H2v-3.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5V8a3 3 0 0 1 6 0v1.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5V14zm-5-3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5m7.5.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0zM9.5 7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5m-3 0a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5m2 7h-1v-2h1z"
                      />
                    </svg>
                    <h4 className="card-title">Manufacturing</h4>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="industires-card-wrapper">
                  <div className="card">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                    >
                      <g fill="none" stroke="#f3792c" stroke-width="4">
                        <rect
                          width="28"
                          height="18"
                          x="16"
                          y="12"
                          stroke-linejoin="round"
                          rx="3"
                        />
                        <path stroke-linecap="round" d="M24 18v6m12-6v6" />
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M36 12V6H24v6m20 24H12a2 2 0 0 1-2-2V11a2 2 0 0 0-2-2H4m15 33a3 3 0 0 1-3-3v-3h6v3a3 3 0 0 1-3 3m18 0a3 3 0 0 1-3-3v-3h6v3a3 3 0 0 1-3 3"
                        />
                      </g>
                    </svg>
                    <h4 className="card-title">Retail & E-commerce</h4>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </>
  );
};

export default IndustriesWeServe;
